export default __webpack_public_path__ + "static/media/plastic-jaw-dentistry-clinic.f7b9128c.jpg";